import { CSSProperties } from 'react';
import { ProductState } from 'client/widget-components/ecom/stores/ProductState';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';

type OldWidgetStyles = {
    wrapper?: CSSProperties;
    fields?: CSSProperties;
    title?: CSSProperties;
};

export type OV_WidgetStyles = {
    wrapper?: ResponsiveStylesStructured;
    title?: ResponsiveStylesStructured;
    fields?: ResponsiveStylesStructured;
};

export interface RuntimeOptionsVariationsProps {
    productState: ProductState;
    _styles?: OldWidgetStyles | OV_WidgetStyles;
    dropdownPlaceholder?: string;
    editorEmptyMessage?: string;
    renderType?: OptionsRenderType;
}

export enum OptionsRenderType {
    DROPDOWN = 'DROPDOWN',
    RADIOBUTTON = 'RADIOBUTTON',
}
